import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between mt-8 -gap-x-8" }
const _hoisted_2 = {
  key: 0,
  class: "col"
}
const _hoisted_3 = { class: "text-subtitle2" }
const _hoisted_4 = { class: "w-full flex justify-between items-center px-2" }

import { RegionDto, ArticleDto, TagType } from 'src/api/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'SvDocumentCards',
  props: {
    region: {},
    articles: {}
  },
  setup(__props: any) {

const props = __props;

const max = (props.region.extraProperties?.max as number) ?? 3;
const articles = props.articles.slice(0, max);
if (articles.length < max) {
  for (let i = 0; i <= max - articles.length; i++) {
    articles.splice(articles.length, 0, {
      id: i.toString(),
      category: '',
      keywords: {
        type: 'default' as TagType,
      },
      creationTime: '',
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(articles), (article) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: article.id
      }, [
        (!article.activeDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : (_openBlock(), _createBlock(_component_q_card, {
              key: 1,
              class: "col flex flex-col justify-between"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_router_link, {
                    to: `/news/${article.id}`
                  }, {
                    default: _withCtx(() => [
                      (article.image)
                        ? (_openBlock(), _createBlock(_component_q_img, {
                            key: 0,
                            src: article.image,
                            alt: article.title,
                            loading: "lazy"
                          }, {
                            loading: _withCtx(() => [
                              _createVNode(_component_q_spinner_dots, {
                                color: "primary",
                                size: "1.5rem"
                              })
                            ]),
                            _: 2
                          }, 1032, ["src", "alt"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: `/news/${article.id}`,
                        class: "text-2xl h-16 hover:text-green-600 cursor-pointer text-multiline-ellipsis"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(article.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((article.summary ?? '').split('\n'), (p, i) => {
                          return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(p), 1))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_q_separator),
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("span", null, _toDisplayString(article.activeDate?.substring(0, 10)), 1),
                        _createVNode(_component_q_icon, {
                          class: "text-xl",
                          name: "mdi-chevron-right"
                        })
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              _: 2
            }, 1024))
      ], 64))
    }), 128))
  ]))
}
}

})